// extracted by mini-css-extract-plugin
export var div = "styles-module--div--1+pOY";
export var h2 = "styles-module--h2--vzl+0";
export var h3 = "styles-module--h3--ycKco";
export var h5 = "styles-module--h5--1mrXu";
export var h6 = "styles-module--h6--78Ix0";
export var privacyPolicyWrapper = "styles-module--privacyPolicyWrapper--aHvmv";
export var ul = "styles-module--ul--o+Kfu";